<template>
 <v-expand-transition>
    <v-alert
        prominent
        color="white"
        min-width="400"
        max-width="1300"
    >
    
<v-col>
    <v-row align="center" justify="center" class="pb-8 black--text">
        
        <div v-if="SFResponse.editStatus === 'INSERTED'">
            <v-row align="center" justify="center" class="">
                <sweetalert-icon icon="success"></sweetalert-icon>
            </v-row>
            {{ $t('applied') }}
                <v-row align="center" justify="center" class="pb-6 black--text">
                <!-- SUCCESS BUTTON -->
                <v-btn
                    @click="overlay = false; success = false; failure = false; resetSFResponse()" 
                    color="green" 
                    to="/completed"
                    Continue
                >
            {{ $t('continue') }}
        </v-btn>
    </v-row>
    </div> 
        <div v-else >
            <v-row align="center" justify="center" class="">
                <sweetalert-icon icon="warning"></sweetalert-icon>
            </v-row>
            <v-row align="center" justify="center" class="pb-6">
                <span>
                {{ $t('failure') }} <br>
                {{ SFResponse.message }}
                </span>
            </v-row>
            <v-row align="center" justify="center" class="">
                <v-btn
                    @click="overlay = false; success = false; failure = false; resetCaptcha(); resetSFResponse()" 
                    color="#F7BB8B"
                    
                >{{$t('close')}}</v-btn>
            </v-row>
        </div>
    </v-row>
    

</v-col>

</v-alert>
</v-expand-transition>
</template>

<script>

import SweetalertIcon from 'vue-sweetalert-icons/src/components/icon';

export default {

    components: { SweetalertIcon },

    methods: {
        resetCaptcha() {
            window.mtcaptcha.resetUI()
        },

        resetSFResponse() {
            self.SFResponse.editStatus = ""
        }
    },

    computed: {
        SFResponse: {
            get () { return this.$store.state.SFResponse },
            set(value ) { this.$store.commit('updateSFResponse', value) }
        },

        overlay: { 
            get () {  return this.$store.state.overlay },
            set(value ) { this.$store.commit('toggleOverlay', value) }
        },

         progresscicle: { 
            get () {  return this.$store.state.progresscicle },
             set(value) { this.$store.commit('toggleProgressCicle', value) }
        },

        success: { 
            get () { return this.$store.state.success },
            set (value) { this.$store.commit('toggleSuccess', value) } 
        },

          failure: { 
            get () { return this.$store.state.failure },
            set (value) { this.$store.commit('toggleFailure', value) } 
        },
    },
    
}
</script>